import { lazy } from 'react';

export const DeductionPage = lazy(() => import('./page-list'));
